import { getDomainName } from "../utils/helper";

// API MOCKS
import {
  commentsByCourse,
  createComment,
  featureComment,
  listReactions,
  reactComment,
} from "../mocks/comment";
import { createChapter, updateChapter } from "../mocks/chapter";
import { createResource, updateResource } from "../mocks/resource";
import {
  changeType,
  createLesson,
  createVideoTimeline,
  saveLessonContent,
  updateLesson,
} from "../mocks/lesson";
import { createQuestion, getResult, updateQuestion } from "../mocks/quiz";

export const API_CONFIG = {
  gateway: `${window.location.protocol}//${getDomainName()}/api/auth-web`,
  mockDelay: 500,
  endpoints: {
    /**
     * Course APIs
     */
    course: "/courses/:pk",

    /**
     * Chapter APIs
     */
    createChapter: { path: "POST:/chapter/create/:courseId", mock: createChapter },
    updateChapter: { path: "PUT:/chapter/:pk", mock: updateChapter },
    deleteChapter: "DELETE:/chapter/:pk",

    /**
     * Lesson APIs
     */
    createLesson: { path: "POST:/lesson/create-lesson/:chapterId", mock: createLesson },
    updateLesson: { path: "PUT:/lesson/:pk/:chapterId", mock: updateLesson },
    deleteLesson: { path: "DELETE:/lesson/:pk", mock: { status: 200 } },

    changeLessonType: { path: "PUT:/lesson/:pk/change-type", mock: changeType },
    updateLessonContent: { path: "PUT:/lesson/:pk/save-lesson-content", mock: saveLessonContent },
    uploadVideo: "POST:/lesson/upload-video",

    changeLessonStatus: { path: "PUT:/lesson/:pk/change-status", mock: { status: 200 } },
    changeLessonOrder: { path: "PUT:/lesson/:pk/change-order", mock: { status: 200 } },

    createResource: { path: "POST:/lesson/resource/create/:lessonId", mock: createResource },
    updateResource: { path: "PUT:/lesson/resource/:pk", mock: updateResource },
    deleteResource: { path: "DELETE:/lesson/resource/:pk", mock: { status: 200 } },
    // chapterApplyResource: "",

    createShortcut: "POST:/lesson/keyboard-shortcut/create/:lessonId",
    deleteShortcut: "DELETE:/lesson/keyboard-shortcut/:pk",

    // Lesson Video
    createTimeline: { path: "POST:/video/:videoId/timeline", mock: createVideoTimeline },
    deleteTimeline: { path: "DELETE:/video/timeline/:pk", mock: { status: 200 } },

    // Lesson progress and is viewed
    updateProgress: { path: "PUT:/lesson/:pk/save-progress", mock: { status: 200 } },
    isLessonViewed: { path: "/lesson/:pk/viewed", mock: { message: "success", status: 1 } },

    /**
     * Comment APIs
     */
    commentByCourse: {
      path: "/comment/by-course/:courseId",
      mock: commentsByCourse,
    },
    commentBlock: "/comment/block-comments/:pk",
    createComment: { path: "POST:/comment/create", mock: createComment },
    updateComment: "PUT:/comment/:pk",
    deleteComment: { path: "DELETE:/comment/:pk", mock: { status: 200 } },
    featureComment: { path: "POST:/comment/:pk/featured", mock: featureComment },
    reactComment: { path: "POST:/comment/:pk/reaction", mock: reactComment },
    listReactions: { path: "/comment/:pk/reaction", mock: listReactions },

    /**
     * Reviews APIs
     */
    review: "/reviews/:pk",
    createReview: "POST:/review",
    updateReview: "PUT:/review/:pk",

    /**
     * Quiz APIs
     */
    updateQuiz: "PUT:/quizzes/:pk",

    /**
     * Question APIs
     */
    createQuestion: {
      path: "POST:/quizzes/:pk/question",
      mock: createQuestion,
    },
    updateQuestion: {
      path: "PUT:/quizzes/question/:pk",
      mock: updateQuestion,
    },
    changeQuestionOrder: { path: "PUT:/quizzes/question/:pk/change-order", mock: { status: 200 } },
    deleteQuestion: { path: "DELETE:/quizzes/question/:pk", mock: { status: 200 } },
    checkQuiz: {
      path: "POST:/quizzes/:pk/check-answer",
      mock: {
        isPassed: true,
        number_of_correct: 2,
        score: 20,
        status: 1,
      },
    },
    getResult: { path: "GET:/quizzes/:pk/answer", mock: getResult },

    /**
     * Error Report APIs
     */
    createErrorReport: { path: "POST:/report-error/create", mock: { status: 200 } },
  },
};
